import { useState } from 'react';
import { Star, Clock, Users, MapPin, Heart, ChevronLeft, ChevronRight } from 'lucide-react';
import Button from '../base/Button';

export default function FeaturedActivities() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [favorites, setFavorites] = useState<number[]>([]);
  const [activeFilter, setActiveFilter] = useState<string>('Tous');

  const activities = [
    {
      id: 1,
      title: "Safari dans le Désert Premium",
      location: "Désert Al Madam",
      price: "55.66",
      originalPrice: "75.00",
      duration: "6 heures",
      groupSize: "Jusqu'à 8 personnes",
      rating: 4.9,
      reviews: 2847,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
      badge: "Bestseller",
      category: "Aventure",
      highlights: ["Dîner bédouin", "Spectacle de danse", "Balade en chameau", "Photos professionnelles"],
      urgent: "Plus que 3 places aujourd'hui"
    },
    {
      id: 2,
      title: "Burj Khalifa + Aquarium",
      location: "Downtown Dubai",
      price: "45.98",
      originalPrice: "65.00",
      duration: "4 heures",
      groupSize: "Accès immédiat",
      rating: 4.8,
      reviews: 1923,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
      badge: "Coupe-file",
      category: "Culture",
      highlights: ["Étage 124 & 125", "Aquarium géant", "Tunnel sous-marin", "Audio guide français"],
      urgent: "Réservation recommandée"
    },
    {
      id: 3,
      title: "Petit-déjeuner avec Girafes",
      location: "Abu Dhabi",
      price: "508.20",
      originalPrice: "580.00",
      duration: "3 heures",
      groupSize: "Session de 4 personnes",
      rating: 5.0,
      reviews: 456,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2023/08/breakfast-with-the-girrafe-dinner-with-elephant-dubai-holidays-vacances-a-dubai.jpeg",
      badge: "Exclusif",
      category: "Luxe",
      highlights: ["Expérience unique", "Petit-déjeuner gourmet", "Photos incluses", "Transport privé"],
      urgent: "Disponibilité limitée"
    },
    {
      id: 4,
      title: "Aquaventure Waterpark",
      location: "Palm Jumeirah",
      price: "79.86",
      originalPrice: "95.00",
      duration: "Journée complète",
      groupSize: "Accès illimité",
      rating: 4.7,
      reviews: 3241,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp",
      badge: "Famille",
      category: "Famille",
      highlights: ["Toboggans géants", "Plage privée", "Aquarium", "Restaurants inclus"],
      urgent: "Offre spéciale weekend"
    },
    {
      id: 5,
      title: "Jetski & Flyboard",
      location: "Dubai Marina",
      price: "84.70",
      originalPrice: "110.00",
      duration: "2 heures",
      groupSize: "1-2 personnes",
      rating: 4.9,
      reviews: 892,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/11/jetski-3.jpg",
      badge: "Aventure",
      category: "Aventure",
      highlights: ["Jetski 30min", "Flyboard 15min", "Équipement inclus", "Instructeur français"],
      urgent: "Météo parfaite"
    },
    {
      id: 6,
      title: "Croisière Musandam",
      location: "Oman",
      price: "145.20",
      originalPrice: "180.00",
      duration: "Journée complète",
      groupSize: "Groupe",
      rating: 4.8,
      reviews: 1567,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/musandam-cruise-.jpg.webp",
      badge: "Nature",
      category: "Nature",
      highlights: ["Fjords d'Arabie", "Déjeuner à bord", "Snorkeling", "Dauphins"],
      urgent: "Départ garanti"
    },
    {
      id: 7,
      title: "Vol en Hélicoptère Dubai",
      location: "Dubai Marina",
      price: "245.00",
      originalPrice: "295.00",
      duration: "25 minutes",
      groupSize: "1-3 personnes",
      rating: 5.0,
      reviews: 623,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/11/jetski-3.jpg",
      badge: "Luxe",
      category: "Luxe",
      highlights: ["Vue panoramique", "Palm Jumeirah", "Burj Al Arab", "Photos incluses"],
      urgent: "Réservation 48h à l'avance"
    },
    {
      id: 8,
      title: "Dubai Frame + Musée du Futur",
      location: "Downtown Dubai",
      price: "38.50",
      originalPrice: "52.00",
      duration: "3 heures",
      groupSize: "Accès immédiat",
      rating: 4.6,
      reviews: 1456,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
      badge: "Culture",
      category: "Culture",
      highlights: ["Dubai Frame", "Musée du Futur", "Audio guide", "Vue 360°"],
      urgent: "Coupe-file inclus"
    },
    {
      id: 9,
      title: "Wild Wadi Waterpark",
      location: "Jumeirah",
      price: "72.30",
      originalPrice: "88.00",
      duration: "Journée complète",
      groupSize: "Famille",
      rating: 4.8,
      reviews: 2134,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2023/08/breakfast-with-the-girrafe-dinner-with-elephant-dubai-holidays-vacances-a-dubai.jpeg",
      badge: "Famille",
      category: "Famille",
      highlights: ["30 toboggans", "Plage artificielle", "Restaurants", "Zone enfants"],
      urgent: "Pack famille -20%"
    },
    {
      id: 10,
      title: "Plongée avec Requins",
      location: "Dubai Aquarium",
      price: "125.00",
      originalPrice: "150.00",
      duration: "2 heures",
      groupSize: "Petit groupe",
      rating: 4.9,
      reviews: 789,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/ce21d131464d69f89d14ea294961b6f00dc75489-1.jpg.webp",
      badge: "Aventure",
      category: "Aventure",
      highlights: ["Requins tigres", "Équipement fourni", "Photos sous-marine", "Instructeur certifié"],
      urgent: "Expérience unique"
    },
    {
      id: 11,
      title: "Dîner Croisière Dhow",
      location: "Dubai Creek",
      price: "68.90",
      originalPrice: "85.00",
      duration: "2 heures",
      groupSize: "Groupe",
      rating: 4.7,
      reviews: 1892,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/safari-dubai-desert-.jpg.webp",
      badge: "Culture",
      category: "Culture",
      highlights: ["Dîner buffet", "Spectacle traditionnel", "Vue sur la ville", "Boissons incluses"],
      urgent: "Départ quotidien"
    },
    {
      id: 12,
      title: "Observation Baleines & Dauphins",
      location: "Golfe Persique",
      price: "95.50",
      originalPrice: "120.00",
      duration: "4 heures",
      groupSize: "Petit groupe",
      rating: 4.8,
      reviews: 567,
      image: "https://mesvacancesadubai.com/wp-content/uploads/2020/12/aquaventure-.jpg.webp",
      badge: "Nature",
      category: "Nature",
      highlights: ["Observation garantie", "Guide naturaliste", "Snack à bord", "Photos offertes"],
      urgent: "Saison optimale"
    }
  ];

  const filteredActivities = activeFilter === 'Tous' 
    ? activities 
    : activities.filter(activity => activity.category === activeFilter);

  const itemsPerPage = 3;
  const maxIndex = Math.max(0, filteredActivities.length - itemsPerPage);

  const nextSlide = () => {
    setCurrentIndex(prev => Math.min(prev + 1, maxIndex));
  };

  const prevSlide = () => {
    setCurrentIndex(prev => Math.max(prev - 1, 0));
  };

  const toggleFavorite = (id: number) => {
    setFavorites(prev => 
      prev.includes(id) 
        ? prev.filter(fav => fav !== id)
        : [...prev, id]
    );
  };

  const handleFilterChange = (filter: string) => {
    setActiveFilter(filter);
    setCurrentIndex(0);
  };

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white" id="activites">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Activités <span className="text-amber-600">Incontournables</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Découvrez notre sélection d'activités testées et approuvées par notre équipe. 
            Réservation instantanée, meilleur prix garanti.
          </p>
          
          {/* Quick filters */}
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {['Tous', 'Aventure', 'Famille', 'Luxe', 'Culture', 'Nature'].map((filter) => (
              <button
                key={filter}
                onClick={() => handleFilterChange(filter)}
                className={`px-6 py-2 rounded-full transition-all ${
                  activeFilter === filter
                    ? 'bg-amber-600 text-white shadow-lg' 
                    : 'bg-white text-gray-700 hover:bg-amber-50 border border-gray-200'
                }`}
              >
                {filter} {activeFilter === filter && `(${filteredActivities.length})`}
              </button>
            ))}
          </div>
        </div>

        {/* Activities Carousel */}
        <div className="relative">
          {/* Navigation buttons */}
          <button
            onClick={prevSlide}
            disabled={currentIndex === 0}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-amber-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
          >
            <ChevronLeft size={24} />
          </button>
          
          <button
            onClick={nextSlide}
            disabled={currentIndex >= maxIndex}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 z-10 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center text-gray-600 hover:text-amber-600 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
          >
            <ChevronRight size={24} />
          </button>

          {/* Activities Grid */}
          <div className="overflow-hidden">
            {filteredActivities.length === 0 ? (
              <div className="text-center py-12">
                <p className="text-gray-500 text-lg">Aucune activité trouvée pour cette catégorie.</p>
              </div>
            ) : (
              <div 
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentIndex * (100 / itemsPerPage)}%)` }}
              >
                {filteredActivities.map((activity) => (
                <div key={activity.id} className="w-1/3 flex-shrink-0 px-3" data-product-shop>
                  <div className="bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden group">
                    {/* Image */}
                    <div className="relative overflow-hidden">
                      <img
                        src={activity.image}
                        alt={activity.title}
                        className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      
                      {/* Badges */}
                      <div className="absolute top-4 left-4 flex flex-col gap-2">
                        <span className="bg-amber-600 text-white px-3 py-1 rounded-full text-sm font-semibold">
                          {activity.badge}
                        </span>
                        {activity.urgent && (
                          <span className="bg-red-500 text-white px-3 py-1 rounded-full text-xs font-medium animate-pulse">
                            {activity.urgent}
                          </span>
                        )}
                      </div>
                      
                      {/* Favorite button */}
                      <button
                        onClick={() => toggleFavorite(activity.id)}
                        className="absolute top-4 right-4 w-10 h-10 bg-white/90 rounded-full flex items-center justify-center hover:bg-white transition-colors"
                      >
                        <Heart 
                          size={20} 
                          className={favorites.includes(activity.id) ? 'text-red-500 fill-current' : 'text-gray-600'} 
                        />
                      </button>
                      
                      {/* Price overlay */}
                      <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg px-3 py-2">
                        <div className="text-right">
                          <div className="text-lg font-bold text-amber-600">€{activity.price}</div>
                          <div className="text-sm text-gray-500 line-through">€{activity.originalPrice}</div>
                        </div>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-6">
                      <div className="flex items-center justify-between mb-3">
                        <div className="flex items-center space-x-1">
                          <Star className="text-amber-400 fill-current" size={16} />
                          <span className="font-semibold text-gray-900">{activity.rating}</span>
                          <span className="text-gray-500 text-sm">({activity.reviews} avis)</span>
                        </div>
                        <div className="flex items-center text-gray-500 text-sm">
                          <MapPin size={14} className="mr-1" />
                          {activity.location}
                        </div>
                      </div>

                      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-amber-600 transition-colors">
                        {activity.title}
                      </h3>

                      <div className="flex items-center justify-between text-sm text-gray-600 mb-4">
                        <div className="flex items-center">
                          <Clock size={14} className="mr-1" />
                          {activity.duration}
                        </div>
                        <div className="flex items-center">
                          <Users size={14} className="mr-1" />
                          {activity.groupSize}
                        </div>
                      </div>

                      {/* Highlights */}
                      <div className="mb-6">
                        <div className="flex flex-wrap gap-1">
                          {activity.highlights.slice(0, 2).map((highlight, index) => (
                            <span key={index} className="bg-amber-50 text-amber-700 px-2 py-1 rounded text-xs">
                              ✓ {highlight}
                            </span>
                          ))}
                          {activity.highlights.length > 2 && (
                            <span className="text-amber-600 text-xs font-medium">
                              +{activity.highlights.length - 2} autres
                            </span>
                          )}
                        </div>
                      </div>

                      {/* CTA */}
                      <div className="flex gap-3">
                        <Button className="flex-1 text-sm py-2">
                          Réserver maintenant
                        </Button>
                        <button className="px-4 py-2 border border-gray-200 rounded-lg hover:border-amber-600 hover:text-amber-600 transition-colors text-sm">
                          Détails
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              </div>
            )}
          </div>
        </div>

        {/* View all button */}
        <div className="text-center mt-12">
          <Button variant="outline" size="lg">
            Voir toutes les activités
          </Button>
        </div>
      </div>
    </section>
  );
}